export default __webpack_public_path__ + "static/media/element_49.e70706bc.webp";